import Component from '@glimmer/component';
import LoadingSpinner from './spinner';

export default class PageLoadingComponent extends Component {
  get message() {
    return this.args.message || 'Loading content...';
  }

  get showSpinner() {
    return this.args.showSpinner !== false;
  }

  <template>
    <div class="page-loading" ...attributes>
      <div class="page-loading__content">
        {{#if this.showSpinner}}
          <LoadingSpinner @size="large" @message={{this.message}} @showMessage={{true}} />
        {{else}}
          <div class="page-loading__message">{{this.message}}</div>
        {{/if}}
        
        {{#if this.args.subtitle}}
          <div class="page-loading__subtitle">{{this.args.subtitle}}</div>
        {{/if}}
      </div>
    </div>

    <style>
      .page-loading {
        min-height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        background-color: var(--bg-color, #f9fafb);
      }

      .page-loading__content {
        text-align: center;
        max-width: 400px;
      }

      .page-loading__message {
        font-size: 1.125rem;
        color: #374151;
        margin-bottom: 0.5rem;
      }

      .page-loading__subtitle {
        font-size: 0.875rem;
        color: #6b7280;
        line-height: 1.5;
      }
    </style>
  </template>
}
